import React, {useEffect, useState,useRef} from "react";
import Styles from './index.module.scss'
import {Platform,paramsToObj,objectToQueryParams} from "@/utils/publicFun";
import gotoBrowserImg from '@/assets/img/culturalExchange_seasons/goto-browser.png';
import operationImg from '@/assets/img/culturalExchange_seasons/pilotOperation.png';
import downloadImg from '@/assets/img/culturalExchange_seasons/download.png';
import buttonOpenImg from '@/assets/img/culturalExchange_seasons/buttonopen.png';
import iPhoneSafaritipsImg from '@/assets/img/culturalExchange_seasons/iPhoneSafaritips.png';
import androidBrowserImg from '@/assets/img/culturalExchange_seasons/Androidbrowsertips.png';

/**
 * @description 茅台联名的落地页
 * @return {/culturalExchange_seasons/LandingPage}
 */

const appSchema = 'gktapp://com.gkewang';
const downloadUrl = 'https://app.gkewang.com/index';
const LandingPage = () => {
  const { fromUrl, appScreen, ...otherParams } = paramsToObj();
    const [goToBrowserMask, setGoToBrowserMask] = useState(false);

    const openApp = () => {
        if (Platform.isWechat()) {
            setGoToBrowserMask(true);
        } else {
            let luanchUrl;
            if (fromUrl) {
                luanchUrl = `${appSchema}/screen/Web?uri=${encodeURIComponent(decodeURIComponent(fromUrl))}${objectToQueryParams(otherParams)}`;
            } else if (appScreen) {
                luanchUrl = `${appSchema}/screen/${appScreen}?${objectToQueryParams(otherParams)}`;
            } else {
                luanchUrl = `${appSchema}`;
            }
            
            window.location.href =luanchUrl;
            setTimeout(() => {
              window.location.href = downloadUrl;
            }, 3000);
            
        }
    }

    if (Platform.isWechat()) {
        return <div className={Styles.container}>
            <img src={operationImg} />
            <div className={Styles.guide}>
                <p>已安装APP请点击右上角</p>
                <p>{Platform.isAndroid() ? '选择在浏览器中打开' : '选择在Safari中打开'}</p>

                <p className={Styles.uninstall}>未安装请下载APP <button onClick={() => {
                    window.location.href = downloadUrl;
                }}>下载APP</button></p>


                <div className={Styles.guidImg}>
                    {Platform.isAndroid() ? <img src={androidBrowserImg} alt='pic' /> : <img src={iPhoneSafaritipsImg} alt='pic' />}
                </div>
            </div>

        </div>
    }
    return <div className={Styles.container}>
        <img src={downloadImg} />
        <button className={Styles.openApp} onClick={openApp}>
            <img src={buttonOpenImg} />
        </button>

        {goToBrowserMask ? <div className={Styles.mask} onClick={() => {
            setGoToBrowserMask(false);
        }}>
            <img src={gotoBrowserImg} />
        </div> : false}

    </div>
}

export default LandingPage
